/** The object detail's tab set: the overview plus the three named tabs. */
export type ObjectDetailTab = 'attributes' | 'relationships' | 'activity';

export type ObjectDetailTabId = 'overview' | ObjectDetailTab;

const TAB_SEGMENTS: readonly ObjectDetailTab[] = ['attributes', 'relationships', 'activity'];

/**
 * Which tab a URL sits on, read from the segment straight after the object id so
 * an object type slugged `activity` can't be mistaken for a tab. Anything that
 * isn't a tab segment (including the tab's own sub-pages, e.g. attributes/edit)
 * keeps its tab selected.
 */
export function activeObjectDetailTab(pathname: string, objectId: string): ObjectDetailTabId {
  const segments = pathname.split('/').filter((segment) => segment !== '');
  const objectIdIndex = segments.lastIndexOf(objectId);
  if (objectIdIndex === -1) return 'overview';
  const next = segments[objectIdIndex + 1];
  return TAB_SEGMENTS.find((tab) => tab === next) ?? 'overview';
}
